
import React, { Component } from "react";

class Footer extends Component {
  render() {
    if (!this.props.data) return null;

    const networks = this.props.data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url} aria-label={network.name}>
            <i className={network.className} aria-hidden="true"></i>
          </a>
        </li>
      );
    });
    const currentYear = new Date().getFullYear();

    return (
      <footer className="site-footer">
        <div className="footer-rule" />
        <div className="footer-content">
          <div className="footer-statement">
            <span className="footer-line">Building thoughtful software</span>
            <span className="footer-line">from <span className="footer-accent">concept to launch—and beyond.</span></span>
          </div>
          <div className="footer-meta">
            <a className="footer-email" href="mailto:me@michaylabenezra.com">me@michaylabenezra.com</a>
            <nav className="footer-links" aria-label="Footer links">
              {networks}
            </nav>
          </div>
          <div className="footer-copyright">&copy; {currentYear} Michayla Ben-Ezra</div>
        </div>
      </footer>
    );
  }
}

export default Footer;
